import { ReferenceChatType } from '@/entities/project/api/generated/model/referenceChatType';
import type { FundingCategory } from '@/features/ai-matching-results/lib/types';

/**
 * AIマッチング結果ページの UI カテゴリ → BE の参照チャット種別（ReferenceChatType）の対応。
 *
 * CLAUDE.md ルール（動的キー生成禁止）に従い、明示的なマッピングで解決する。
 *
 * 注意: BE の「特別交付税 / 都道府県の特別交付税」とは厳密には軸が異なるが、
 * ITA-2528 の方針として以下の対応で連携する。
 * - 特別交付税（旧・調査票） → prefectural_special_allocation_taxes
 *
 * 特別交付税（省令 = special_allocation_taxes）はマッチング導線を廃止したため、
 * 本マッピングでは扱わない（汎用AIチャットのナレッジ専用）。
 * `revenue_expenditure_account_items`（歳入歳出科目）は対応する UI カテゴリが無く、本対応では扱わない。
 */
export const CATEGORY_TO_REFERENCE_CHAT_TYPE: Record<FundingCategory, ReferenceChatType> = {
  'special-allocation-tax-survey': ReferenceChatType.prefectural_special_allocation_taxes,
  'national-grants': ReferenceChatType.national_grants,
  'prefectural-grants': ReferenceChatType.prefectural_grants,
};
